import { useState } from 'react';
import config from '@cof/ukweb-config/lib/clientConfig';
import { useAxios, useAxiosCallback } from '../hooks/useAxios';
import getConfig from './config';
import { adobeData } from '../api/client/adobeParams';
import * as promises from '../utilities/promises';

const ARTIFICIAL_DELAY = 1500;

export const useFormData = (params: any) => useAxiosCallback(() => ({ ...getConfig('form'), params }));

export const useObStartData = (data: any) => useAxios(() => ({ ...getConfig('obStart'), data, method: 'post' }));

export const useObCompleteData = (data: any) =>
    useAxiosCallback(() => ({ ...getConfig('obComplete'), data, method: 'post' }));

export const useFormSubmit = () => {
    const [delaying, setDelaying] = useState(false);
    const [submitForm, submitting, ...rest] = useAxiosCallback((data: any) => {
        setDelaying(true);
        setTimeout(() => setDelaying(false), ARTIFICIAL_DELAY);
        const { downstreamVersionIsEnabled } = config.get('useDownstreamVersion') || {};
        return withAsyncData(
            {
                ...getConfig('quotation'),
                withCredentials: downstreamVersionIsEnabled ? true : undefined,
                data,
                method: 'post'
            },
            adobeData()
        );
    });

    return [submitForm, submitting || delaying, ...rest];
};

export const useAddressLookupData = (sessionId: any, upstreamTarget?: string) =>
    useAxiosCallback((data: any) => {
        const headers = {
            ...getConfig('addressLookup').headers,
            ...{ 'Session-Id': sessionId, 'x_upstream_env': upstreamTarget }
        };
        return { ...getConfig('addressLookup'), headers, data, method: 'post' };
    });

export const useStageData = (sessionId: any) =>
    useAxiosCallback((data: any) => {
        const headers = { ...getConfig('stage').headers, ...{ 'Session-Id': sessionId } };
        return { ...getConfig('stage'), headers, data, method: 'post' };
    });

export const shouldShowTechError = (brand: any) => {
    const { brands } = config.get('showTechError');
    return brands.map((x: any) => x.toLowerCase()).includes(brand.toLowerCase());
};

export const withAsyncData = (originalPayload: any, data: any) =>
    // @ts-expect-error TS2554: Expected 2 arguments, but got 1.
    promises.safe(data).then((p) => ({ ...originalPayload, data: { ...originalPayload.data, ...p } }));
